import LoadableImage from "../LoadableImage";
import Navigation from "../Navigation";
import BackLink from "../BackLink";
import ForwardLink from "../ForwardLink";
import {useEffect} from "react";

function Page26() {
  useEffect(() => {
    document.title = "Маяк — Страница 25"
  }, []);

  return (
    <>
      <Navigation />

      <div className="NavigationLink-wrapper">
        <BackLink href="/page24" />
        <ForwardLink href="/page26" />
      </div>

      <p style={{ textAlign: "right" }}>25.</p>
      <p>Долгая, мучительная пауза.</p>
      <p style={{ textAlign: "center" }}>
        МОЛОДОЙ<br/>
        Есть, сэр.
      </p>
      <p style={{ textAlign: "center" }}>
        СТАРИК<br/>
        Теперь мой, пес. Мой!
      </p>
      <p>
        МОЛОДОЙ делает, как ему говорят: берет швабру и ведро, <u>окончательно<br/>
        смирившись со своей судьбой на этой маячной станции</u>.
      </p>
      <p>СТАРИК улыбается.</p>
      <p style={{ textAlign: "center" }}>
        СТАРИК (ПРОДОЛЖЕНИЕ)<br/>
        Вот это молодец. Вот, что<br/>
        я хочу видеть.
      </p>
      <p>МОЛОДОЙ начинает мыть пол.</p>
      <p>СТАРИК насмешливо поет:</p>
      <p style={{ textAlign: "center" }}>
        СТАРИК (ПРОДОЛЖЕНИЕ)<br/>
        (поет)<br/>
        <i>О, что может быть проклятием<br/>
        жизни хранителя маяка?<br/>
        Что заставляет его волноваться,<br/>
        драться и ссориться,<br/>
        Что заставляет его ругаться<br/>
        и бить жену?<br/>
        Это «Brasswork».</i>
      </p>
      <br/>
      <p>ВНУТРИ. КОТЕЛЬНАЯ – ПОЗЖЕ</p>
      <p>СТАРИК наблюдает, как МОЛОДОЙ полирует медь.</p>
      <p style={{ textAlign: "center" }}>
        СТАРИК<br/>
        (поет)<br/>
        <i>Что заставляет его выглядеть ужасным,<br/>
        чахоточным и худым?<br/>
        Что лишает его здоровья,<br/>
        энергии и силы?<br/>
        И вызывает у него отчаяние и доводит<br/>
        до греха.<br/>
        Это «Brasswork».</i>
      </p>
      <p>МОЛОДОЙ продолжает полировать... сильнее... быстрее... сильнее...</p>
      <br/>
      <p>СНАРУЖИ. КАМЕННЫЙ ОСТРОВ – ДЕНЬ</p>
      <p>
        МОЛОДОЙ толкает тачку сквозь шторм (теперь
        в другом направлении). Это сложнее, чем раньше...
      </p>
      <p style={{ textAlign: "right" }}>25.</p>
      
      <Navigation />
      
      <div className="NavigationLink-wrapper">
        <BackLink href="/page24" />
        <ForwardLink href="/page26" />
      </div>

      <LoadableImage
        src="https://res.cloudinary.com/linuxmachinecloud/image/upload/v1710015665/the-lighthouse-script/nkrqssgmqr9nsqhhfgav.jpg"
        alt="Иллюстрация"
      />
    </>
  );
}

export default Page26;
